import { render, staticRenderFns } from "./face-recognition.vue?vue&type=template&id=5a563298&scoped=true"
import script from "./face-recognition.vue?vue&type=script&lang=js"
export * from "./face-recognition.vue?vue&type=script&lang=js"
import style0 from "./face-recognition.vue?vue&type=style&index=0&id=5a563298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a563298",
  null
  
)

export default component.exports